<template class="d-flex">
  <v-container>
    <v-row class=" container text-center flex-column margin-center">
     <v-col class="mb-4" v-if="!isLoggedIn" style="text-decoration:none;">
        <h1 class="my-3 mt-0 sheadline text-left font-weight-bold mb-3">
          Poštovani članovi 
        </h1>
          <v-img
            :src="require('../assets/logo.svg')"
            class="my-3"
            contain
          />
        <p class="subheading text-left font-weight-medium pt-2 pb-2">
          I ove godine nastavljamo sa Bilstein Group Club programom, koji startuje 1. jula 2026. i trajaće do 31. oktobra 2026.
        </p>
        <p class="subheading text-left font-weight-medium pt-2 pb-2">
          Prijavom na svoj postojeći profil možete na početku svakog meseca (do 15. u mesecu) proveriti Vaše bodove za prethodni period. Na Vašem profilu u gornjem levom uglu možete promeniti  dobavljače ukoliko je došlo do izmene u prethodnom periodu.
        </p>
        <p class="subheading text-left font-weight-medium pt-2 pb-2">Za sve one koji se nisu registrovali, pozivamo Vas da to uradite sada kako bi skupljali bodove i bili nagrađeni za kupljene delove brendova <b>febi, SWAG i Blue Print.</b></p>
        <p class="subheading text-left font-weight-medium pt-2 pb-2">Sav promet koji napravite od meseca kada ste se registrovali pa do kraja akcije, kod direktnih dobavljača koje ste izabrali prilikom registracije, biće obračunat na kraju svakog meseca i dodat u obliku nagradnih bodova na Vaš nalog.</p>
        <p class="subheading text-left font-weight-medium pt-2 pb-2">Za promet od 100 RSD ostvaruje se 4 nagradna boda, a svaki bod vredi 1 RSD.</p>
        <p class="subheading text-left font-weight-medium pt-2 pb-2">Nakon završetka akcije, dobija se MasterCard poklon kartica sa novčanom sumom koja je ostvarena. Minimalni iznos koji treba ostvariti da biste imali pravo na nagradu je 5.000 RSD, dok je maksimalni iznos koji je moguće ostvariti 50.000 RSD.</p>
        <p><b>Za sva pitanja možete kontaktirati info centar putem email adrese: <a href="mailto:club@bilsteingroup.com">club@bilsteingroup.com</a></b></p>
          <v-img
            :src="require('../assets/febi-swag-blue-print.svg')"
            class="my-3"
            contain
          />
          <p><b>Mogu da se prijave samo registrovani servisi sa validnim PIB brojem.</b></p>
      </v-col>

      <v-col class="mb-4" v-if="isLoggedIn" style="text-decoration:none;">
               <h1 class="my-3 mt-0 sheadline text-left font-weight-bold mb-3">
          Poštovani članovi 
        </h1>
          <v-img
            :src="require('../assets/logo.svg')"
            class="my-3"
            contain
          />
        <p class="subheading text-left font-weight-medium pt-2 pb-2">
          I ove godine nastavljamo sa Bilstein Group Club programom, koji startuje 1. jula 2026. i trajaće do 31. oktobra 2026.
        </p>
        <p class="subheading text-left font-weight-medium pt-2 pb-2">
          Prijavom na svoj postojeći profil možete na početku svakog meseca (do 15. u mesecu) proveriti Vaše bodove za prethodni period. Na Vašem profilu u gornjem levom uglu možete promeniti  dobavljače ukoliko je došlo do izmene u prethodnom periodu.
        </p>
        <p class="subheading text-left font-weight-medium pt-2 pb-2">Za sve one koji se nisu registrovali, pozivamo vas da to uradite sada kako bi skupljali bodove i bili nagrađeni za kupljene delove brendova <b>febi, SWAG i Blue Print.</b></p>
        <p class="subheading text-left font-weight-medium pt-2 pb-2">Sav promet koji napravite od meseca kada ste se registrovali pa do kraja akcije, kod direktnih dobavljača koje ste izabrali prilikom registracije, biće obračunat na kraju svakog meseca i dodat u obliku nagradnih bodova na Vaš nalog.</p>
        <p class="subheading text-left font-weight-medium pt-2 pb-2">Za promet od 100 RSD ostvaruje se 4 nagradna boda, a svaki bod vredi 1 RSD.</p>
        <p class="subheading text-left font-weight-medium pt-2 pb-2">Nakon završetka akcije, dobija se MasterCard poklon kartica sa novčanom sumom koja je ostvarena. Minimalni iznos koji treba ostvariti da biste imali pravo na nagradu je 5.000 RSD, dok je maksimalni iznos koji je moguće ostvariti 50.000 RSD.</p>
        <p><b>Za sva pitanja možete kontaktirati info centar putem email adrese: <a href="mailto:club@bilsteingroup.com">club@bilsteingroup.com</a></b></p>
          <v-img
            :src="require('../assets/febi-swag-blue-print.svg')"
            class="my-3"
            contain
          />
      </v-col>

      <v-col>
        <div class="text-center md-5">
          <router-link v-if="!isLoggedIn" to="/Registracija" style="text-decoration:none;">
            <v-btn width="-webkit-fill-available"   height="50" rounded color="primary" dark>Prijavite se</v-btn>
          </router-link>
          <router-link v-if="isLoggedIn" to="/Bodovi" style="text-decoration:none;">
            <v-btn width="-webkit-fill-available"   height="50" rounded color="primary" dark>Vaši bodovi</v-btn>
          </router-link>
        </div>
      </v-col>
    
    
    
    </v-row>
  </v-container>
</template>

<script>
  import firebase from 'firebase';
  import {db,fb} from '../main'
  export default {
    name: 'Dashboard',
  data: () => ({
      isLoggedIn:false,
      currentUser:false,  
      history: [],
      points: []

    }),

    created() {
      // if(!window.location.hash) {
      //     window.location = window.location + '#loaded';
      //     location.reload(true);
      // }
      if(firebase.auth().currentUser) {
        this.isLoggedIn = true,
        this.currentUser = firebase.auth().currentUser.uid
      }
      this.readDataPoints()  
      this.readDataHistory()  

    },

    methods: {
        readDataHistory() {
              const user = fb.auth().currentUser
              db.collection(`accounts`).doc(user.uid).collection('history').get().then((querySnapshot) => { if (!querySnapshot.empty){
              querySnapshot.forEach((doc) => {
                  this.history.push(doc.data())
                  })
                }
            else  {
               db.collection(`accounts`).doc(user.uid).collection('history').doc("2").set({
      
                    monthFirst:'Mart',
                    monthSecond:'April',
                    monthThird:'Maj',
                    monthFourth:'Jun',
                    monthFifth:'Jul',
                    monthSixth:'Avgust',
                    monthSeven:'Septembar',

                    blueprintFirst: 0,
                    swagFirst: 0,
                    febiFirst: 0,
                    blueprintSecond: 0,
                    swagSecond: 0,
                    febiSecond: 0,
                    blueprintThird: 0,
                    swagThird: 0,
                    febiThird: 0,
                    blueprintFourth: 0,
                    swagFourth: 0,
                    febiFourth: 0,
                    blueprintFifth: 0,
                    swagFifth: 0,
                    febiFifth: 0,
                    blueprintSixth: 0,
                    swagSixth: 0,
                    febiSixth: 0,
                    blueprintSeven: 0,
                    swagSeven: 0,
                    febiSeven: 0,

                })
              
            }
          }) 
          
        },
        readDataPoints() {
    
          const user = fb.auth().currentUser
          db.collection(`accounts`).doc(user.uid).collection('points').get().then((querySnapshot) => { if (!querySnapshot.empty) {
           querySnapshot.forEach((doc) => {
                this.points.push(doc.data())
              })
            }
            else  {
               db.collection(`accounts`).doc(user.uid).collection('points').doc("1").set({
                    blueprint: 0,
                    swag: 0,
                    febi: 0
                })

            }
          })
  

          
        },
      logout: function(){
        firebase.auth().signOut().then(() => {
          this.$router.push('/')
        })
      },

    }
  }
  
</script>
<style>
  .v-btn__content {
    font-size: 18px;
  }
</style>